export const API_ENDPOINTS = {
  // Applicant & Job Applications
  PROCESS_NEW_APPLICANT_SUBMISSION:
    '/FTSJobApplication/ProcessNewFTSApplicantSubmission',
  PROCESS_EXISTING_APPLICANT_SUBMISSION:
    '/FTSJobApplication/ProcessExistingFTSApplicantSubmission',
  PROCESS_FTS_APPLICATION_SUBMISSION:
    '/FTSJobApplication/ProcessFTSApplicationSubmission',
  GET_SPECIFIC_APPLICANT_DATA_FOR_PREFILL:
    '/FTSJobApplication/GetFTSApplicantDataForPrefill',

  // Job & Dashboard
  GET_JOBS_FOR_FTS_DASHBOARD:
    '/FTSAccountHolderDashboard/GetJobsForFtsDashboard',
  GET_JOBS_FOR_MY_FTS_APPLICATIONS:
    '/FTSAccountHolderDashboard/GetJobsForMyFtsApplications',

  // Job Details
  GET_JOB_DETAILS: (ftsJobId: string) =>
    `/FTSJobAccountHolder/FTSJobDetails/${ftsJobId}`,
  GET_JOB_HISTORY: (ftsJobId: string) => `/History/FTSJobHistory/${ftsJobId}`,

  // Correction Requests
  GET_CORRECTION_REQUEST_REASONS:
    '/FTSJobAccountHolder/GetCorrectionRequestReasonDropdown',
  SUBMIT_CORRECTION_REQUEST:
    '/FTSJobAccountHolder/RequestTranslationCorrection',
  WITHDRAW_CORRECTION_REQUEST:
    '/FTSJobAccountHolder/WithdrawTranslationCorrection',

  // User & Account Holder
  CREATE_FTS_ACCOUNT: '/FTSAccountHolder/ProcessFTSAccountHolder',
  VERIFY_FTS_ACCOUNT_SMS: '/FTSAccountHolder/VerifyFtsAccountHolderSms',
  SEND_EMAIL_VERIFICATION_CODE: '/FTSAccountHolder/SendEmailVerificationCode',
  SEND_SMS_FOR_UPDATE: '/FTSAccountHolder/SendFtsAccountHolderSmsForUpdate',
  GET_AUTHENTICATED_ACCOUNT_HOLDER:
    '/FTSAccountHolder/GetAuthenticatedFTSAccountHolder',
  UPDATE_ACCOUNT_HOLDER: '/FTSAccountHolder/UpdateFTSAccountHolder',

  // File Operations
  UPLOAD_FILE: '/File/UploadFile',
  GET_FINAL_TRANSLATION_DOC_URL: (translationJobId: number) =>
    `/File/GetFinalOutputDocumentUrl/${translationJobId}`,
  DOWNLOAD_DOCUMENT: (documentGuid: string) =>
    `/File/DownloadDocument/Download/${documentGuid}`,

  // Document Validity Check
  CHECK_DOCUMENT_VALIDITY: '/DocumentValidityCheck/CheckDocumentValidity',
  POLL_DOCUMENT_VALIDITY: '/DocumentValidityCheck/Poll',

  // Schema related
  GET_LATEST_BOOKING_SCHEMA: '/Schema/GetLatestBookingDataSchema',
  GET_BOOKING_SCHEMA_FOR_JOB: (jobId: string) =>
    `/Schema/GetBookingDataSchemaForJob/${jobId}`,
  GET_LANGUAGES_AVAILABLE: '/Schema/LanguagesAvailableForFTSJobs',
  GET_BOOKING_DOCUMENT_TYPES: '/Schema/GetFTSBookingDocumentTypes',
  GET_COUNTRIES: '/Schema/GetTravelDocumentCountries',

  // Amendments
  AMEND_FTS_JOB: '/FTSJobAccountHolder/AmendFTSJob',
  GET_AMENDMENT_REQUEST_TYPE_SCHEMA: (jobId: string) =>
    `/Schema/GetAmendmentRequestTypes/${jobId}`,
};
